// ----------------------------------------------------------------------

export function paramCase(str: string): string {
  return str
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

// ----------------------------------------------------------------------

export function snakeCase(str: string): string {
  return str
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

// ----------------------------------------------------------------------

export function sentenceCase(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// ----------------------------------------------------------------------
/**
 * Converts a translation key (e.g. "incomeInformationLabel") to a readable fallback ("Income Information Label").
 * Use only as defaultValue in t(key, { defaultValue: humanizeLabelKey(key) }) so we never show raw keys in the UI.
 * Display-only: does not affect form logic, validation, or submit flow.
 */
export function humanizeLabelKey(key: string): string {
  if (!key || typeof key !== 'string') return key || '';
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (s) => s.toUpperCase())
    .trim();
}
